import formatDate from '@ps-int/ufo-helpers/lib/date/date-to-string';

import { i18n } from './i18n';

export const getRecordFileName = (time: Date | number) => {
    const prefix = i18n('record', 'file-name-prefix');
    const date = formatDate(time, 'DD.MM.YYYY HH-mm-ss');
    const postfix = i18n('record', 'file-name-postfix-record');
    return `${prefix} ${date} - ${postfix}.webm`;
};
